// Currently available types for CvTextInput
export const inputTypes = new Set(['password', 'text']);
export const sizeTypes = new Set(['sm', 'md', 'lg', 'xl']);
